import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import withStyles from '@mui/styles/withStyles';


import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';

import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';

import FormLabel from '@mui/material/FormLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';

import Breadcrumbs from '@mui/material/Breadcrumbs';

import AddIcon from '@mui/icons-material/AddCircle';
import RemoveIcon from '@mui/icons-material/RemoveCircle';

import { green } from '@mui/material/colors';

const styles = theme => ({
        

    buttonControl: {
        margin: '8px 0px 8px 16px'
    },

    actionContainer: {
        display: 'flex',
        width: '100%',
        flexDirection: 'row-reverse',
        marginBottom: theme.spacing(3)
    },


    buttonProgress: {
        color: green[500],
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginTop: -12,
        marginLeft: -12
    },


    link: theme.style.link,  


    button: {
        margin: theme.spacing(1)
    },
    leftIcon: {
        marginRight: theme.spacing(1)
    },
    iconSmall: {
        fontSize: 20
    }
});



class AdministrationTransporteur extends React.Component {
             

    render() {
        let { classes, selectedTransporteur, onChange, onClickSave, isPatching, sauvegardable, onClickAddCode, onClickRemoveCode, onChangeCode, onChangeCompte } = this.props;


        let selectedTransporteurType = selectedTransporteur ? `${selectedTransporteur.type}` : '0';

        return (
            <>



                {selectedTransporteur && (
                    <>

                        <Helmet>
                            <title>{`Transporteur : ${selectedTransporteur.code}`}</title>
                        </Helmet>

                        <Typography gutterBottom variant="h5">
                            Édition du transporteur : {selectedTransporteur.code}
                        </Typography>


                        <Breadcrumbs separator="›" arial-label="breadcrumb">
                            <Link to={`/administration/transporteurs/`} className={classes.link}>
                                <Typography variant="button">
                                    Transporteurs
                                </Typography>
                            </Link>

                            <Typography color="textPrimary">{selectedTransporteur.code}</Typography>
                        </Breadcrumbs>


                        <Paper sx={{padding:2}}>

                            <Typography gutterBottom variant="h6">
                                Paramètres
                            </Typography>

                            <TextField
                                id="code"
                                name="code"
                                label="Code"
                                placeholder="Code"
                                required
                                value={selectedTransporteur.code}
                                disabled
                                fullWidth
                            />

                            <TextField sx={{marginTop: 1}}
                                id="nom"
                                name="nom"
                                label="Nom"
                                placeholder="Nom"
                                required
                                value={selectedTransporteur.nom}
                                onChange={onChange}
                                fullWidth
                            />


                            <FormControl margin="normal">
                                <FormLabel component="legend">Type</FormLabel>
                                <RadioGroup
                                    aria-label="type"
                                    name="type"
                                    className={classes.group}
                                    value={selectedTransporteurType}
                                    onChange={onChange}
                                    style={{ flexDirection : 'row' }}
                                >
                                    <FormControlLabel value="0" control={<Radio />} label="Messager" />
                                    <FormControlLabel value="1" control={<Radio />} label="Expressiste" />
                                </RadioGroup>
                            </FormControl>


                            <Grid container spacing={1} sx={{ alignItems: 'center' }}>
                                <Grid item xs={12}>
                                    <p>Codes transporteur logistique</p>
                                </Grid>

                                {selectedTransporteur.transporteursLogistique.map((tl, index) => (
                                    <>
                                    
                                        <Grid item xs={2} sx={{ flexGrow: 1 }}>
                                            <TextField
                                                id={"code" + index}
                                                name={"code" + index}
                                                label={"code"}
                                                placeholder="Code"
                                                required
                                                value={tl.code}
                                                onChange={e => onChangeCode(index, e.target.value)}
                                                fullWidth
                                            />
                                        </Grid>

                                        <Grid item xs={1} sx={{ flexGrow: 1 }}>

                                            <TextField
                                                id={"transporteurCompte" + index}
                                                name={"transporteurCompte" + index}
                                                label={"compte"}
                                                value={tl.transporteurCompteId ? tl.transporteurCompteId : 0}
                                                onChange={e => onChangeCompte(index, e.target.value)}
                                                fullWidth

                                                select
                                            >

                                                <MenuItem key={0} value={0}><em>Aucun</em></MenuItem>

                                                {selectedTransporteur.comptes && selectedTransporteur.comptes.map((compte, index) => (

                                                    <MenuItem key={index} value={compte.id}>
                                                        {compte.compte}
                                                    </MenuItem>
                                                ))}

                                            </TextField>
                                        </Grid>

                                        <Grid item xs={9} sx={{ justifyContent: 'flex-start' }}>
                                            <Button variant="contained" size="small" className={classes.button} onClick={(e) => onClickRemoveCode(index)}>
                                                <RemoveIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                                                Supprimer
                                            </Button>
                                        </Grid>

                                    </>

                                ))}



                            </Grid>



                            <Button variant="contained" size="small" className={classes.button} onClick={onClickAddCode}>
                                <AddIcon className={classNames(classes.leftIcon, classes.iconSmall)} />
                                Nouveau code
                            </Button>

                        </Paper>


                        <div className={classes.actionContainer} >

                            <Link to="/administration/transporteurs">
                                <Button
                                    className={classes.buttonControl}
                                    disabled={!sauvegardable || isPatching}
                                    onClick={onClickSave}
                                    variant="contained"
                                    color="secondary"
                                >
                                    Enregistrer
                                    {isPatching === true && <CircularProgress size={24} className={classes.buttonProgress} />}
                                </Button>
                            </Link>
                            <Link to="/administration/transporteurs">
                                <Button className={classes.buttonControl} color="primary" >
                                    Annuler
                                </Button>
                            </Link>
                        </div>

                    </>
                )}


            </>
        );
    }
}

AdministrationTransporteur.propTypes = {
    classes: PropTypes.object.isRequired,
    onClickCancel: PropTypes.func.isRequired,
    onClickSave: PropTypes.func.isRequired,

    onClickAddCode: PropTypes.func.isRequired,
    onClickRemoveCode: PropTypes.func.isRequired,
    

    onChange: PropTypes.func.isRequired,

    sauvegardable: PropTypes.bool.isRequired,
    isPatching: PropTypes.bool.isRequired,
    selectedTransporteur: PropTypes.object
};

export default withStyles(styles)(AdministrationTransporteur);